import React from 'react'
import { useTranslation } from 'react-i18next'
import './LanguagesButton.scss'

const LANGUAGES = [
    { code: 'ru', label: 'RU', title: 'Русский' },
    { code: 'en', label: 'EN', title: 'English' },
    { code: 'es', label: 'ES', title: 'Español' },
]

export const LanguagesButton = ({ direction = 'left' } = {}) => {
    const { i18n } = useTranslation()
    const currentLang = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0]

    return (
        <div className={`LanguagesButton ${direction}`}>
            <div className="accordion" role="listbox">
                {LANGUAGES.filter((lang) => lang.code !== i18n.language).map((lang) => (
                    <button
                        key={lang.code}
                        type="button"
                        role="option"
                        aria-selected={i18n.language === lang.code}
                        className={`lang ${i18n.language === lang.code ? 'is-active' : ''}`}
                        onClick={() => i18n.changeLanguage(lang.code)}
                        title={lang.title}
                    >
                        {lang.label}
                    </button>
                ))}
            </div>
            <div className="trigger">
                <button
                    type="button"
                    className="lang"
                    title={currentLang.title}
                    aria-expanded="false"
                    aria-haspopup="listbox"
                >
                    {currentLang.label}
                </button>
            </div>

        </div>
    )
}